function e(e) {
  function t(e, t) {
    Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = e, this.code = t;
  }
  return t.prototype = new Error(), t.prototype.name = e, t.prototype.constructor = t, t;
}
const t = e("LaunchDarklyUnexpectedResponseError"),
  n = e("LaunchDarklyInvalidEnvironmentIdError"),
  r = e("LaunchDarklyInvalidUserError"),
  o = e("LaunchDarklyInvalidEventKeyError"),
  i = e("LaunchDarklyInvalidArgumentError"),
  a = e("LaunchDarklyFlagFetchError");
for (var s = {
    LDUnexpectedResponseError: t,
    LDInvalidEnvironmentIdError: n,
    LDInvalidUserError: r,
    LDInvalidEventKeyError: o,
    LDInvalidArgumentError: i,
    LDInvalidDataError: e("LaunchDarklyInvalidDataError"),
    LDFlagFetchError: a,
    LDTimeoutError: e("LaunchDarklyTimeoutError"),
    isHttpErrorRecoverable: function (e) {
      return !(e >= 400 && e < 500) || 400 === e || 408 === e || 429 === e;
    }
  }, c = function (e) {
    var t = m(e),
      n = t[0],
      r = t[1];
    return 3 * (n + r) / 4 - r;
  }, u = function (e) {
    var t,
      n,
      r = m(e),
      o = r[0],
      i = r[1],
      a = new g(function (e, t, n) {
        return 3 * (t + n) / 4 - n;
      }(0, o, i)),
      s = 0,
      c = i > 0 ? o - 4 : o;
    for (n = 0; n < c; n += 4) t = f[e.charCodeAt(n)] << 18 | f[e.charCodeAt(n + 1)] << 12 | f[e.charCodeAt(n + 2)] << 6 | f[e.charCodeAt(n + 3)], a[s++] = t >> 16 & 255, a[s++] = t >> 8 & 255, a[s++] = 255 & t;
    2 === i && (t = f[e.charCodeAt(n)] << 2 | f[e.charCodeAt(n + 1)] >> 4, a[s++] = 255 & t);
    1 === i && (t = f[e.charCodeAt(n)] << 10 | f[e.charCodeAt(n + 1)] << 4 | f[e.charCodeAt(n + 2)] >> 2, a[s++] = t >> 8 & 255, a[s++] = 255 & t);
    return a;
  }, l = function (e) {
    for (var t, n = e.length, r = n % 3, o = [], i = 16383, a = 0, s = n - r; a < s; a += i) o.push(y(e, a, a + i > s ? s : a + i));
    1 === r ? (t = e[n - 1], o.push(d[t >> 2] + d[t << 4 & 63] + "==")) : 2 === r && (t = (e[n - 2] << 8) + e[n - 1], o.push(d[t >> 10] + d[t >> 4 & 63] + d[t << 2 & 63] + "="));
    return o.join("");
  }, d = [], f = [], g = "undefined" != typeof Uint8Array ? Uint8Array : Array, v = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", p = 0; p < 64; ++p) d[p] = v[p], f[v.charCodeAt(p)] = p;
function m(e) {
  var t = e.length;
  if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  return -1 === n && (n = t), [n, n === t ? 0 : 4 - n % 4];
}
function h(e) {
  return d[e >> 18 & 63] + d[e >> 12 & 63] + d[e >> 6 & 63] + d[63 & e];
}
function y(e, t, n) {
  for (var r, o = [], i = t; i < n; i += 3) r = (e[i] << 16 & 16711680) + (e[i + 1] << 8 & 65280) + (255 & e[i + 2]), o.push(h(r));
  return o.join("");
}
f["-".charCodeAt(0)] = 62, f["_".charCodeAt(0)] = 63;
var w = {
    byteLength: c,
    toByteArray: u,
    fromByteArray: l
  },
  b = Array.isArray,
  k = Object.keys,
  E = Object.prototype.hasOwnProperty,
  D = function e(t, n) {
    if (t === n) return !0;
    if (t && n && "object" == typeof t && "object" == typeof n) {
      var r,
        o,
        i,
        a = b(t),
        s = b(n);
      if (a && s) {
        if ((o = t.length) != n.length) return !1;
        for (r = o; 0 !== r--;) if (!e(t[r], n[r])) return !1;
        return !0;
      }
      if (a != s) return !1;
      var c = t instanceof Date,
        u = n instanceof Date;
      if (c != u) return !1;
      if (c && u) return t.getTime() == n.getTime();
      var l = t instanceof RegExp,
        d = n instanceof RegExp;
      if (l != d) return !1;
      if (l && d) return t.toString() == n.toString();
      var f = k(t);
      if ((o = f.length) !== k(n).length) return !1;
      for (r = o; 0 !== r--;) if (!E.call(n, f[r])) return !1;
      for (r = o; 0 !== r--;) if (!e(t[i = f[r]], n[i])) return !1;
      return !0;
    }
    return t != t && n != n;
  };
const x = ["key", "ip", "country", "email", "firstName", "lastName", "avatar", "name"];
function O(e) {
  const t = unescape(encodeURIComponent(e));
  return w.fromByteArray(function (e) {
    const t = [];
    for (let n = 0; n < e.length; n++) t.push(e.charCodeAt(n));
    return t;
  }(t));
}
function C(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
var P,
  S = {
    appendUrlPath: function (e, t) {
      return (e.endsWith("/") ? e.substring(0, e.length - 1) : e) + (t.startsWith("/") ? "" : "/") + t;
    },
    base64URLEncode: function (e) {
      return O(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    },
    btoa: O,
    clone: function (e) {
      return JSON.parse(JSON.stringify(e));
    },
    deepEquals: function (e, t) {
      return D(e, t);
    },
    extend: function () {
      for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
        e[_key] = arguments[_key];
      }
      return e.reduce((e, t) => ({
        ...e,
        ...t
      }), {});
    },
    getLDUserAgentString: function (e) {
      const t = e.version || "?";
      return e.userAgent + "/" + t;
    },
    objectHasOwnProperty: C,
    onNextTick: function (e) {
      setTimeout(e, 0);
    },
    sanitizeContext: function (e) {
      if (!e) return e;
      let t;
      return null !== e.kind && void 0 !== e.kind || x.forEach(n => {
        const r = e[n];
        void 0 !== r && "string" != typeof r && (t = t || {
          ...e
        }, t[n] = String(r));
      }), t || e;
    },
    transformValuesToVersionedValues: function (e) {
      const t = {};
      for (const n in e) C(e, n) && (t[n] = {
        value: e[n],
        version: 0
      });
      return t;
    },
    transformVersionedValuesToValues: function (e) {
      const t = {};
      for (const n in e) C(e, n) && (t[n] = e[n].value);
      return t;
    },
    wrapPromiseCallback: function (e, t) {
      const n = e.then(e => (t && setTimeout(() => {
        t(null, e);
      }, 0), e), e => {
        if (!t) return Promise.reject(e);
        setTimeout(() => {
          t(e, null);
        }, 0);
      });
      return t ? void 0 : n;
    },
    once: function (e) {
      let t,
        n = !1;
      return function () {
        for (var _len2 = arguments.length, r = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          r[_key2] = arguments[_key2];
        }
        return n || (n = !0, t = e.apply(this, r)), t;
      };
    }
  },
  I = new Uint8Array(16);
function T() {
  if (!P && !(P = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return P(I);
}
var F = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function L(e) {
  return "string" == typeof e && F.test(e);
}
for (var U, A, j = [], R = 0; R < 256; ++R) j.push((R + 256).toString(16).substr(1));
function N(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0,
    n = (j[e[t + 0]] + j[e[t + 1]] + j[e[t + 2]] + j[e[t + 3]] + "-" + j[e[t + 4]] + j[e[t + 5]] + "-" + j[e[t + 6]] + j[e[t + 7]] + "-" + j[e[t + 8]] + j[e[t + 9]] + "-" + j[e[t + 10]] + j[e[t + 11]] + j[e[t + 12]] + j[e[t + 13]] + j[e[t + 14]] + j[e[t + 15]]).toLowerCase();
  if (!L(n)) throw TypeError("Stringified UUID is invalid");
  return n;
}
var $ = 0,
  V = 0;
function H(e) {
  if (!L(e)) throw TypeError("Invalid UUID");
  var t,
    n = new Uint8Array(16);
  return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = 255 & t, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = 255 & t, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = 255 & t, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = 255 & t, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = 255 & t, n;
}
function M(e, t, n) {
  function r(e, r, o, i) {
    if ("string" == typeof e && (e = function (e) {
      e = unescape(encodeURIComponent(e));
      for (var t = [], n = 0; n < e.length; ++n) t.push(e.charCodeAt(n));
      return t;
    }(e)), "string" == typeof r && (r = H(r)), 16 !== r.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var a = new Uint8Array(16 + e.length);
    if (a.set(r), a.set(e, r.length), (a = n(a))[6] = 15 & a[6] | t, a[8] = 63 & a[8] | 128, o) {
      i = i || 0;
      for (var s = 0; s < 16; ++s) o[i + s] = a[s];
      return o;
    }
    return N(a);
  }
  try {
    r.name = e;
  } catch (e) {}
  return r.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", r.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", r;
}
function q(e) {
  return 14 + (e + 64 >>> 9 << 4) + 1;
}
function z(e, t) {
  var n = (65535 & e) + (65535 & t);
  return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
}
function K(e, t, n, r, o, i) {
  return z((a = z(z(t, e), z(r, i))) << (s = o) | a >>> 32 - s, n);
  var a, s;
}
function _(e, t, n, r, o, i, a) {
  return K(t & n | ~t & r, e, t, o, i, a);
}
function J(e, t, n, r, o, i, a) {
  return K(t & r | n & ~r, e, t, o, i, a);
}
function B(e, t, n, r, o, i, a) {
  return K(t ^ n ^ r, e, t, o, i, a);
}
function W(e, t, n, r, o, i, a) {
  return K(n ^ (t | ~r), e, t, o, i, a);
}
var G = M("v3", 48, function (e) {
    if ("string" == typeof e) {
      var t = unescape(encodeURIComponent(e));
      e = new Uint8Array(t.length);
      for (var n = 0; n < t.length; ++n) e[n] = t.charCodeAt(n);
    }
    return function (e) {
      for (var t = [], n = 32 * e.length, r = "0123456789abcdef", o = 0; o < n; o += 8) {
        var i = e[o >> 5] >>> o % 32 & 255,
          a = parseInt(r.charAt(i >>> 4 & 15) + r.charAt(15 & i), 16);
        t.push(a);
      }
      return t;
    }(function (e, t) {
      e[t >> 5] |= 128 << t % 32, e[q(t) - 1] = t;
      for (var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, a = 0; a < e.length; a += 16) {
        var s = n,
          c = r,
          u = o,
          l = i;
        n = _(n, r, o, i, e[a], 7, -680876936), i = _(i, n, r, o, e[a + 1], 12, -389564586), o = _(o, i, n, r, e[a + 2], 17, 606105819), r = _(r, o, i, n, e[a + 3], 22, -1044525330), n = _(n, r, o, i, e[a + 4], 7, -176418897), i = _(i, n, r, o, e[a + 5], 12, 1200080426), o = _(o, i, n, r, e[a + 6], 17, -1473231341), r = _(r, o, i, n, e[a + 7], 22, -45705983), n = _(n, r, o, i, e[a + 8], 7, 1770035416), i = _(i, n, r, o, e[a + 9], 12, -1958414417), o = _(o, i, n, r, e[a + 10], 17, -42063), r = _(r, o, i, n, e[a + 11], 22, -1990404162), n = _(n, r, o, i, e[a + 12], 7, 1804603682), i = _(i, n, r, o, e[a + 13], 12, -40341101), o = _(o, i, n, r, e[a + 14], 17, -1502002290), n = J(n, r = _(r, o, i, n, e[a + 15], 22, 1236535329), o, i, e[a + 1], 5, -165796510), i = J(i, n, r, o, e[a + 6], 9, -1069501632), o = J(o, i, n, r, e[a + 11], 14, 643717713), r = J(r, o, i, n, e[a], 20, -373897302), n = J(n, r, o, i, e[a + 5], 5, -701558691), i = J(i, n, r, o, e[a + 10], 9, 38016083), o = J(o, i, n, r, e[a + 15], 14, -660478335), r = J(r, o, i, n, e[a + 4], 20, -405537848), n = J(n, r, o, i, e[a + 9], 5, 568446438), i = J(i, n, r, o, e[a + 14], 9, -1019803690), o = J(o, i, n, r, e[a + 3], 14, -187363961), r = J(r, o, i, n, e[a + 8], 20, 1163531501), n = J(n, r, o, i, e[a + 13], 5, -1444681467), i = J(i, n, r, o, e[a + 2], 9, -51403784), o = J(o, i, n, r, e[a + 7], 14, 1735328473), n = B(n, r = J(r, o, i, n, e[a + 12], 20, -1926607734), o, i, e[a + 5], 4, -378558), i = B(i, n, r, o, e[a + 8], 11, -2022574463), o = B(o, i, n, r, e[a + 11], 16, 1839030562), r = B(r, o, i, n, e[a + 14], 23, -35309556), n = B(n, r, o, i, e[a + 1], 4, -1530992060), i = B(i, n, r, o, e[a + 4], 11, 1272893353), o = B(o, i, n, r, e[a + 7], 16, -155497632), r = B(r, o, i, n, e[a + 10], 23, -1094730640), n = B(n, r, o, i, e[a + 13], 4, 681279174), i = B(i, n, r, o, e[a], 11, -358537222), o = B(o, i, n, r, e[a + 3], 16, -722521979), r = B(r, o, i, n, e[a + 6], 23, 76029189), n = B(n, r, o, i, e[a + 9], 4, -640364487), i = B(i, n, r, o, e[a + 12], 11, -421815835), o = B(o, i, n, r, e[a + 15], 16, 530742520), n = W(n, r = B(r, o, i, n, e[a + 2], 23, -995338651), o, i, e[a], 6, -198630844), i = W(i, n, r, o, e[a + 7], 10, 1126891415), o = W(o, i, n, r, e[a + 14], 15, -1416354905), r = W(r, o, i, n, e[a + 5], 21, -57434055), n = W(n, r, o, i, e[a + 12], 6, 1700485571), i = W(i, n, r, o, e[a + 3], 10, -1894986606), o = W(o, i, n, r, e[a + 10], 15, -1051523), r = W(r, o, i, n, e[a + 1], 21, -2054922799), n = W(n, r, o, i, e[a + 8], 6, 1873313359), i = W(i, n, r, o, e[a + 15], 10, -30611744), o = W(o, i, n, r, e[a + 6], 15, -1560198380), r = W(r, o, i, n, e[a + 13], 21, 1309151649), n = W(n, r, o, i, e[a + 4], 6, -145523070), i = W(i, n, r, o, e[a + 11], 10, -1120210379), o = W(o, i, n, r, e[a + 2], 15, 718787259), r = W(r, o, i, n, e[a + 9], 21, -343485551), n = z(n, s), r = z(r, c), o = z(o, u), i = z(i, l);
      }
      return [n, r, o, i];
    }(function (e) {
      if (0 === e.length) return [];
      for (var t = 8 * e.length, n = new Uint32Array(q(t)), r = 0; r < t; r += 8) n[r >> 5] |= (255 & e[r / 8]) << r % 32;
      return n;
    }(e), 8 * e.length));
  }),
  X = G;
function Q(e, t, n, r) {
  switch (e) {
    case 0:
      return t & n ^ ~t & r;
    case 1:
    case 3:
      return t ^ n ^ r;
    case 2:
      return t & n ^ t & r ^ n & r;
  }
}
function Y(e, t) {
  return e << t | e >>> 32 - t;
}
var Z = M("v5", 80, function (e) {
    var t = [1518500249, 1859775393, 2400959708, 3395469782],
      n = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
    if ("string" == typeof e) {
      var r = unescape(encodeURIComponent(e));
      e = [];
      for (var o = 0; o < r.length; ++o) e.push(r.charCodeAt(o));
    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
    e.push(128);
    for (var i = e.length / 4 + 2, a = Math.ceil(i / 16), s = new Array(a), c = 0; c < a; ++c) {
      for (var u = new Uint32Array(16), l = 0; l < 16; ++l) u[l] = e[64 * c + 4 * l] << 24 | e[64 * c + 4 * l + 1] << 16 | e[64 * c + 4 * l + 2] << 8 | e[64 * c + 4 * l + 3];
      s[c] = u;
    }
    s[a - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), s[a - 1][14] = Math.floor(s[a - 1][14]), s[a - 1][15] = 8 * (e.length - 1) & 4294967295;
    for (var d = 0; d < a; ++d) {
      for (var f = new Uint32Array(80), g = 0; g < 16; ++g) f[g] = s[d][g];
      for (var v = 16; v < 80; ++v) f[v] = Y(f[v - 3] ^ f[v - 8] ^ f[v - 14] ^ f[v - 16], 1);
      for (var p = n[0], m = n[1], h = n[2], y = n[3], w = n[4], b = 0; b < 80; ++b) {
        var k = Math.floor(b / 20),
          E = Y(p, 5) + Q(k, m, h, y) + w + t[k] + f[b] >>> 0;
        w = y, y = h, h = Y(m, 30) >>> 0, m = p, p = E;
      }
      n[0] = n[0] + p >>> 0, n[1] = n[1] + m >>> 0, n[2] = n[2] + h >>> 0, n[3] = n[3] + y >>> 0, n[4] = n[4] + w >>> 0;
    }
    return [n[0] >> 24 & 255, n[0] >> 16 & 255, n[0] >> 8 & 255, 255 & n[0], n[1] >> 24 & 255, n[1] >> 16 & 255, n[1] >> 8 & 255, 255 & n[1], n[2] >> 24 & 255, n[2] >> 16 & 255, n[2] >> 8 & 255, 255 & n[2], n[3] >> 24 & 255, n[3] >> 16 & 255, n[3] >> 8 & 255, 255 & n[3], n[4] >> 24 & 255, n[4] >> 16 & 255, n[4] >> 8 & 255, 255 & n[4]];
  }),
  ee = Z;
var te = Object.freeze({
  __proto__: null,
  v1: function (e, t, n) {
    var r = t && n || 0,
      o = t || new Array(16),
      i = (e = e || {}).node || U,
      a = void 0 !== e.clockseq ? e.clockseq : A;
    if (null == i || null == a) {
      var s = e.random || (e.rng || T)();
      null == i && (i = U = [1 | s[0], s[1], s[2], s[3], s[4], s[5]]), null == a && (a = A = 16383 & (s[6] << 8 | s[7]));
    }
    var c = void 0 !== e.msecs ? e.msecs : Date.now(),
      u = void 0 !== e.nsecs ? e.nsecs : V + 1,
      l = c - $ + (u - V) / 1e4;
    if (l < 0 && void 0 === e.clockseq && (a = a + 1 & 16383), (l < 0 || c > $) && void 0 === e.nsecs && (u = 0), u >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $ = c, V = u, A = a;
    var d = (1e4 * (268435455 & (c += 122192928e5)) + u) % 4294967296;
    o[r++] = d >>> 24 & 255, o[r++] = d >>> 16 & 255, o[r++] = d >>> 8 & 255, o[r++] = 255 & d;
    var f = c / 4294967296 * 1e4 & 268435455;
    o[r++] = f >>> 8 & 255, o[r++] = 255 & f, o[r++] = f >>> 24 & 15 | 16, o[r++] = f >>> 16 & 255, o[r++] = a >>> 8 | 128, o[r++] = 255 & a;
    for (var g = 0; g < 6; ++g) o[r + g] = i[g];
    return t || N(o);
  },
  v3: X,
  v4: function (e, t, n) {
    var r = (e = e || {}).random || (e.rng || T)();
    if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
      n = n || 0;
      for (var o = 0; o < 16; ++o) t[n + o] = r[o];
      return t;
    }
    return N(r);
  },
  v5: ee,
  NIL: "00000000-0000-0000-0000-000000000000",
  version: function (e) {
    if (!L(e)) throw TypeError("Invalid UUID");
    return parseInt(e.substr(14, 1), 16);
  },
  validate: L,
  stringify: N,
  parse: H
});
const ne = ["debug", "info", "warn", "error", "none"];
var re = {
  commonBasicLogger: function (e, t) {
    if (e && e.destination && "function" != typeof e.destination) throw new Error("destination for basicLogger was set to a non-function");
    function n(e) {
      return function (t) {
        console && console[e] && console[e].call(console, t);
      };
    }
    const r = e && e.destination ? [e.destination, e.destination, e.destination, e.destination] : [n("log"), n("info"), n("warn"), n("error")],
      o = !(!e || !e.destination),
      i = e && void 0 !== e.prefix && null !== e.prefix ? e.prefix : "[LaunchDarkly] ";
    let a = 1;
    if (e && e.level) for (let t = 0; t < ne.length; t++) ne[t] === e.level && (a = t);
    function s(e, n, a) {
      if (a.length < 1) return;
      let s;
      const c = o ? n + ": " + i : i;
      if (1 !== a.length && t) {
        const e = [...a];
        e[0] = c + e[0], s = t(...e);
      } else s = c + a[0];
      try {
        r[e](s);
      } catch (e) {
        console && console.log && console.log("[LaunchDarkly] Configured logger's " + n + " method threw an exception: " + e);
      }
    }
    const c = {};
    for (let e = 0; e < ne.length; e++) {
      const t = ne[e];
      if ("none" !== t) if (e < a) c[t] = () => {};else {
        const n = e;
        c[t] = function () {
          s(n, t, arguments);
        };
      }
    }
    return c;
  },
  validateLogger: function (e) {
    ne.forEach(t => {
      if ("none" !== t && (!e[t] || "function" != typeof e[t])) throw new Error("Provided logger instance must support logger." + t + "(...) method");
    });
  }
};
function oe(e) {
  return e && e.message ? e.message : "string" == typeof e || e instanceof String ? e : JSON.stringify(e);
}
const ie = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initialize-the-client for instructions on SDK initialization.";
var ae = {
  bootstrapInvalid: function () {
    return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
  },
  bootstrapOldFormat: function () {
    return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + ie;
  },
  clientInitialized: function () {
    return "LaunchDarkly client initialized";
  },
  clientNotReady: function () {
    return "LaunchDarkly client is not ready";
  },
  debugEnqueueingEvent: function (e) {
    return 'enqueueing "' + e + '" event';
  },
  debugPostingDiagnosticEvent: function (e) {
    return "sending diagnostic event (" + e.kind + ")";
  },
  debugPostingEvents: function (e) {
    return "sending " + e + " events";
  },
  debugStreamDelete: function (e) {
    return 'received streaming deletion for flag "' + e + '"';
  },
  debugStreamDeleteIgnored: function (e) {
    return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
  },
  debugStreamPatch: function (e) {
    return 'received streaming update for flag "' + e + '"';
  },
  debugStreamPatchIgnored: function (e) {
    return 'received streaming update for flag "' + e + '" but ignored due to version check';
  },
  debugStreamPing: function () {
    return "received ping message from stream";
  },
  debugPolling: function (e) {
    return "polling for feature flags at " + e;
  },
  debugStreamPut: function () {
    return "received streaming update for all flags";
  },
  deprecated: function (e, t) {
    return t ? '"' + e + '" is deprecated, please use "' + t + '"' : '"' + e + '" is deprecated';
  },
  environmentNotFound: function () {
    return "Environment not found. Double check that you specified a valid environment/client-side ID." + ie;
  },
  environmentNotSpecified: function () {
    return "No environment/client-side ID was specified." + ie;
  },
  errorFetchingFlags: function (e) {
    return "Error fetching flag settings: " + oe(e);
  },
  eventCapacityExceeded: function () {
    return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
  },
  eventWithoutContext: function () {
    return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
  },
  httpErrorMessage: function (e, t, n) {
    return "Received error " + e + (401 === e ? " (invalid SDK key)" : "") + " for " + t + " - " + (s.isHttpErrorRecoverable(e) ? n : "giving up permanently");
  },
  httpUnavailable: function () {
    return "Cannot make HTTP requests in this environment." + ie;
  },
  identifyDisabled: function () {
    return "identify() has no effect here; it must be called on the main client instance";
  },
  inspectorMethodError: (e, t) => `an inspector: "${t}" of type: "${e}" generated an exception`,
  invalidContentType: function (e) {
    return 'Expected application/json content type but got "' + e + '"';
  },
  invalidData: function () {
    return "Invalid data received from LaunchDarkly; connection may have been interrupted";
  },
  invalidInspector: (e, t) => `an inspector: "${t}" of an invalid type (${e}) was configured`,
  invalidKey: function () {
    return "Event key must be a string";
  },
  invalidMetricValue: e => `The track function was called with a non-numeric "metricValue" (${e}), only numeric metric values are supported.`,
  invalidContext: function () {
    return "Invalid context specified." + ie;
  },
  invalidTagValue: e => `Config option "${e}" must only contain letters, numbers, ., _ or -.`,
  localStorageUnavailable: function (e) {
    return "local storage is unavailable: " + oe(e);
  },
  networkError: e => "network error" + (e ? " (" + e + ")" : ""),
  optionBelowMinimum: (e, t, n) => 'Config option "' + e + '" was set to ' + t + ", changing to minimum value of " + n,
  streamClosing: function () {
    return "Closing stream connection";
  },
  streamConnecting: function (e) {
    return "Opening stream connection to " + e;
  },
  streamError: function (e, t) {
    return "Error on stream connection: " + oe(e) + ", will continue retrying after " + t + " milliseconds.";
  },
  tagValueTooLong: e => `Value of "${e}" was longer than 64 characters and was discarded.`,
  unknownCustomEventKey: function (e) {
    return 'Custom event "' + e + '" does not exist';
  },
  unknownOption: e => 'Ignoring unknown config option "' + e + '"',
  contextNotSpecified: function () {
    return "No context specified." + ie;
  },
  unrecoverableStreamError: e => `Error on stream connection ${oe(e)}, giving up permanently`,
  wrongOptionType: (e, t, n) => 'Config option "' + e + '" should be of type ' + t + ", got " + n + ", using default value",
  wrongOptionTypeBoolean: (e, t) => 'Config option "' + e + '" should be a boolean, got ' + t + ", converting to boolean"
};
const {
    validateLogger: se
  } = re,
  ce = {
    baseUrl: {
      default: "https://app.launchdarkly.com"
    },
    streamUrl: {
      default: "https://clientstream.launchdarkly.com"
    },
    eventsUrl: {
      default: "https://events.launchdarkly.com"
    },
    sendEvents: {
      default: !0
    },
    streaming: {
      type: "boolean"
    },
    sendLDHeaders: {
      default: !0
    },
    requestHeaderTransform: {
      type: "function"
    },
    sendEventsOnlyForVariation: {
      default: !1
    },
    useReport: {
      default: !1
    },
    evaluationReasons: {
      default: !1
    },
    eventCapacity: {
      default: 100,
      minimum: 1
    },
    flushInterval: {
      default: 2e3,
      minimum: 2e3
    },
    samplingInterval: {
      default: 0,
      minimum: 0
    },
    streamReconnectDelay: {
      default: 1e3,
      minimum: 0
    },
    allAttributesPrivate: {
      default: !1
    },
    privateAttributes: {
      default: []
    },
    bootstrap: {
      type: "string|object"
    },
    diagnosticRecordingInterval: {
      default: 9e5,
      minimum: 2e3
    },
    diagnosticOptOut: {
      default: !1
    },
    wrapperName: {
      type: "string"
    },
    wrapperVersion: {
      type: "string"
    },
    stateProvider: {
      type: "object"
    },
    application: {
      validator: function (e, t, n) {
        const r = {};
        t.id && (r.id = de(`${e}.id`, t.id, n));
        t.version && (r.version = de(`${e}.version`, t.version, n));
        return r;
      }
    },
    inspectors: {
      default: []
    },
    hooks: {
      default: []
    },
    plugins: {
      default: []
    }
  },
  ue = /^(\w|\.|-)+$/;
function le(e) {
  return e && e.replace(/\/+$/, "");
}
function de(e, t, n) {
  if ("string" == typeof t && t.match(ue)) {
    if (!(t.length > 64)) return t;
    n.warn(ae.tagValueTooLong(e));
  } else n.warn(ae.invalidTagValue(e));
}
var fe = {
  baseOptionDefs: ce,
  validate: function (e, t, n, r) {
    const o = S.extend({
        logger: {
          default: r
        }
      }, ce, n),
      i = {};
    function a(e) {
      S.onNextTick(() => {
        t && t.maybeReportError(new s.LDInvalidArgumentError(e));
      });
    }
    let c = S.extend({}, e || {});
    return function (e) {
      const t = e;
      Object.keys(i).forEach(e => {
        if (void 0 !== t[e]) {
          const n = i[e];
          r && r.warn(ae.deprecated(e, n)), n && (void 0 === t[n] && (t[n] = t[e]), delete t[e]);
        }
      });
    }(c), c = function (e) {
      const t = S.extend({}, e);
      return Object.keys(o).forEach(e => {
        void 0 !== t[e] && null !== t[e] || (t[e] = o[e] && o[e].default);
      }), t;
    }(c), c = function (e) {
      const t = S.extend({}, e),
        n = e => {
          if (null === e) return "any";
          if (void 0 === e) return;
          if (Array.isArray(e)) return "array";
          const t = typeof e;
          return "boolean" === t || "string" === t || "number" === t || "function" === t ? t : "object";
        };
      return Object.keys(e).forEach(i => {
        const s = e[i];
        if (null != s) {
          const c = o[i];
          if (void 0 === c) a(ae.unknownOption(i));else {
            const o = c.type || n(c.default),
              u = c.validator;
            if (u) {
              const n = u(i, e[i], r);
              void 0 !== n ? t[i] = n : delete t[i];
            } else if ("any" !== o) {
              const e = o.split("|"),
                r = n(s);
              e.indexOf(r) < 0 ? "boolean" === o ? (t[i] = !!s, a(ae.wrongOptionTypeBoolean(i, r))) : (a(ae.wrongOptionType(i, o, r)), t[i] = c.default) : "number" === r && void 0 !== c.minimum && s < c.minimum && (a(ae.optionBelowMinimum(i, s, c.minimum)), t[i] = c.minimum);
            }
          }
        }
      }), t.baseUrl = le(t.baseUrl), t.streamUrl = le(t.streamUrl), t.eventsUrl = le(t.eventsUrl), t;
    }(c), se(c.logger), c;
  },
  getTags: function (e) {
    const t = {};
    return e && (e.application && void 0 !== e.application.id && null !== e.application.id && (t["application-id"] = [e.application.id]), e.application && void 0 !== e.application.version && null !== e.application.id && (t["application-version"] = [e.application.version])), t;
  }
};
const {
  getLDUserAgentString: ge
} = S;
var ve = {
  getLDHeaders: function (e, t) {
    if (t && !t.sendLDHeaders) return {};
    const n = {};
    n[e.userAgentHeaderName || "User-Agent"] = ge(e), t && t.wrapperName && (n["X-LaunchDarkly-Wrapper"] = t.wrapperVersion ? t.wrapperName + "/" + t.wrapperVersion : t.wrapperName);
    const r = fe.getTags(t),
      o = Object.keys(r);
    return o.length && (n["x-launchdarkly-tags"] = o.sort().map(e => Array.isArray(r[e]) ? r[e].sort().map(t => `${e}/${t}`) : [`${e}/${r[e]}`]).reduce((e, t) => e.concat(t), []).join(" ")), n;
  },
  transformHeaders: function (e, t) {
    return t && t.requestHeaderTransform ? t.requestHeaderTransform({
      ...e
    }) : e;
  }
};
const {
    v1: pe
  } = te,
  {
    getLDHeaders: me,
    transformHeaders: he
  } = ve;
var ye = function (e, t, n) {
  const r = S.extend({
      "Content-Type": "application/json"
    }, me(e, n)),
    o = {};
  return o.sendEvents = (t, o, i) => {
    if (!e.httpRequest) return Promise.resolve();
    const a = JSON.stringify(t),
      c = i ? null : pe();
    return function t(u) {
      const l = i ? r : S.extend({}, r, {
        "X-LaunchDarkly-Event-Schema": "4",
        "X-LaunchDarkly-Payload-ID": c
      });
      return e.httpRequest("POST", o, he(l, n), a).promise.then(e => {
        if (e) return e.status >= 400 && s.isHttpErrorRecoverable(e.status) && u ? t(!1) : function (e) {
          const t = {
              status: e.status
            },
            n = e.header("date");
          if (n) {
            const e = Date.parse(n);
            e && (t.serverTime = e);
          }
          return t;
        }(e);
      }).catch(() => u ? t(!1) : Promise.reject());
    }(!0).catch(() => {});
  }, o;
};
var we = function e(t) {
  let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (null === t || "object" != typeof t) return JSON.stringify(t);
  if (n.includes(t)) throw new Error("Cycle detected");
  if (Array.isArray(t)) {
    return `[${t.map(r => e(r, [...n, t])).map(e => void 0 === e ? "null" : e).join(",")}]`;
  }
  return `{${Object.keys(t).sort().map(r => {
    const o = e(t[r], [...n, t]);
    if (void 0 !== o) return `${JSON.stringify(r)}:${o}`;
  }).filter(e => void 0 !== e).join(",")}}`;
};
const {
  commonBasicLogger: be
} = re;
function ke(e) {
  return "string" == typeof e && "kind" !== e && e.match(/^(\w|\.|-)+$/);
}
function Ee(e) {
  return e.includes("%") || e.includes(":") ? e.replace(/%/g, "%25").replace(/:/g, "%3A") : e;
}
var De = {
  checkContext: function (e, t) {
    if (e) {
      if (t && (void 0 === e.kind || null === e.kind)) return void 0 !== e.key && null !== e.key;
      const n = e.key,
        r = void 0 === e.kind ? "user" : e.kind,
        o = ke(r),
        i = "multi" === r || null != n && "" !== n;
      if ("multi" === r) {
        const t = Object.keys(e).filter(e => "kind" !== e);
        return i && t.every(e => ke(e)) && t.every(t => {
          const n = e[t].key;
          return null != n && "" !== n;
        });
      }
      return i && o;
    }
    return !1;
  },
  getContextKeys: function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : be();
    if (!e) return;
    const n = {},
      {
        kind: r,
        key: o
      } = e;
    switch (r) {
      case void 0:
        n.user = `${o}`;
        break;
      case "multi":
        Object.entries(e).filter(_ref => {
          let [e] = _ref;
          return "kind" !== e;
        }).forEach(_ref2 => {
          let [e, t] = _ref2;
          t && t.key && (n[e] = t.key);
        });
        break;
      case null:
        t.warn(`null is not a valid context kind: ${e}`);
        break;
      case "":
        t.warn(`'' is not a valid context kind: ${e}`);
        break;
      default:
        n[r] = `${o}`;
    }
    return n;
  },
  getContextKinds: function (e) {
    return e ? null === e.kind || void 0 === e.kind ? ["user"] : "multi" !== e.kind ? [e.kind] : Object.keys(e).filter(e => "kind" !== e) : [];
  },
  getCanonicalKey: function (e) {
    if (e) {
      if ((void 0 === e.kind || null === e.kind || "user" === e.kind) && e.key) return e.key;
      if ("multi" !== e.kind && e.key) return `${e.kind}:${Ee(e.key)}`;
      if ("multi" === e.kind) return Object.keys(e).sort().filter(e => "kind" !== e).map(t => `${t}:${Ee(e[t].key)}`).join(":");
    }
  }
};
const {
  getContextKinds: xe
} = De;
var Oe = function () {
  const e = {};
  let t = 0,
    n = 0,
    r = {},
    o = {};
  return e.summarizeEvent = e => {
    if ("feature" === e.kind) {
      const i = e.key + ":" + (null !== e.variation && void 0 !== e.variation ? e.variation : "") + ":" + (null !== e.version && void 0 !== e.version ? e.version : ""),
        a = r[i];
      let s = o[e.key];
      s || (s = new Set(), o[e.key] = s), function (e) {
        return e.context ? xe(e.context) : e.contextKeys ? Object.keys(e.contextKeys) : [];
      }(e).forEach(e => s.add(e)), a ? a.count = a.count + 1 : r[i] = {
        count: 1,
        key: e.key,
        version: e.version,
        variation: e.variation,
        value: e.value,
        default: e.default
      }, (0 === t || e.creationDate < t) && (t = e.creationDate), e.creationDate > n && (n = e.creationDate);
    }
  }, e.getSummary = () => {
    const e = {};
    let i = !0;
    for (const t of Object.values(r)) {
      let n = e[t.key];
      n || (n = {
        default: t.default,
        counters: [],
        contextKinds: [...o[t.key]]
      }, e[t.key] = n);
      const r = {
        value: t.value,
        count: t.count
      };
      void 0 !== t.variation && null !== t.variation && (r.variation = t.variation), void 0 !== t.version && null !== t.version ? r.version = t.version : r.unknown = !0, n.counters.push(r), i = !1;
    }
    return i ? null : {
      startDate: t,
      endDate: n,
      features: e,
      kind: "summary"
    };
  }, e.clearSummary = () => {
    t = 0, n = 0, r = {}, o = {};
  }, e;
};
var Ce = function (e) {
  let t = {},
    n = {};
  return {
    summarizeEvent: function (e) {
      if ("feature" === e.kind) {
        const r = we(e.context);
        if (!r) return;
        let o = t[r];
        o || (t[r] = Oe(), o = t[r], n[r] = e.context), o.summarizeEvent(e);
      }
    },
    getSummaries: function () {
      const r = t,
        o = n;
      return t = {}, n = {}, Object.entries(r).map(_ref3 => {
        let [t, n] = _ref3;
        const r = n.getSummary();
        return r.context = e.filter(o[t]), r;
      });
    }
  };
};
function Pe(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Se(e) {
  return (e.startsWith("/") ? e.substring(1) : e).split("/").map(e => e.indexOf("~") >= 0 ? e.replace(/~1/g, "/").replace(/~0/g, "~") : e);
}
function Ie(e) {
  return !e.startsWith("/");
}
function Te(e, t) {
  const n = Ie(e),
    r = Ie(t);
  if (n && r) return e === t;
  if (n) {
    const n = Se(t);
    return 1 === n.length && e === n[0];
  }
  if (r) {
    const n = Se(e);
    return 1 === n.length && t === n[0];
  }
  return e === t;
}
function Fe(e) {
  return `/${Pe(e)}`;
}
var Le = {
  cloneExcluding: function (e, t) {
    const n = [],
      r = {},
      o = [];
    for (n.push(...Object.keys(e).map(t => ({
      key: t,
      ptr: Fe(t),
      source: e,
      parent: r,
      visited: [e]
    }))); n.length;) {
      const e = n.pop();
      if (t.some(t => Te(t, e.ptr))) o.push(e.ptr);else {
        const t = e.source[e.key];
        if (null === t) e.parent[e.key] = t;else if (Array.isArray(t)) e.parent[e.key] = [...t];else if ("object" == typeof t) {
          if (e.visited.includes(t)) continue;
          e.parent[e.key] = {}, n.push(...Object.keys(t).map(n => {
            return {
              key: n,
              ptr: (r = e.ptr, o = Pe(n), `${r}/${o}`),
              source: t,
              parent: e.parent[e.key],
              visited: [...e.visited, t]
            };
            var r, o;
          }));
        } else e.parent[e.key] = t;
      }
    }
    return {
      cloned: r,
      excluded: o.sort()
    };
  },
  compare: Te,
  literalToReference: Fe
};
var Ue = function (e) {
  const t = {},
    n = e.allAttributesPrivate,
    r = e.privateAttributes || [],
    o = ["key", "kind", "_meta", "anonymous"],
    i = ["name", "ip", "firstName", "lastName", "email", "avatar", "country"],
    a = (e, t) => {
      if ("object" != typeof e || null === e || Array.isArray(e)) return;
      const {
        cloned: i,
        excluded: a
      } = Le.cloneExcluding(e, ((e, t) => (n || t && e.anonymous ? Object.keys(e) : [...r, ...(e._meta && e._meta.privateAttributes || [])]).filter(e => !o.some(t => Le.compare(e, t))))(e, t));
      return i.key = String(i.key), a.length && (i._meta || (i._meta = {}), i._meta.redactedAttributes = a), i._meta && (delete i._meta.privateAttributes, 0 === Object.keys(i._meta).length && delete i._meta), void 0 !== i.anonymous && (i.anonymous = !!i.anonymous), i;
    };
  return t.filter = function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    return void 0 === e.kind || null === e.kind ? a((e => {
      const t = {
        ...(e.custom || {}),
        kind: "user",
        key: e.key
      };
      void 0 !== e.anonymous && (t.anonymous = !!e.anonymous);
      for (const n of i) delete t[n], void 0 !== e[n] && null !== e[n] && (t[n] = String(e[n]));
      return void 0 !== e.privateAttributeNames && null !== e.privateAttributeNames && (t._meta = t._meta || {}, t._meta.privateAttributes = e.privateAttributeNames.map(e => e.startsWith("/") ? Le.literalToReference(e) : e)), t;
    })(e), t) : "multi" === e.kind ? ((e, t) => {
      const n = {
          kind: e.kind
        },
        r = Object.keys(e);
      for (const o of r) if ("kind" !== o) {
        const r = a(e[o], t);
        r && (n[o] = r);
      }
      return n;
    })(e, t) : a(e, t);
  }, t;
};
const {
  getContextKeys: Ae
} = De;
var je = function (e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
  let o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  let i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  const a = {},
    c = i || ye(e, n, t),
    u = S.appendUrlPath(t.eventsUrl, "/events/bulk/" + n),
    l = Ue(t),
    d = Ce(l),
    f = t.samplingInterval,
    g = t.eventCapacity,
    v = t.flushInterval,
    p = t.logger;
  let m,
    h = [],
    y = 0,
    w = !1,
    b = !1;
  function k() {
    return 0 === f || 0 === Math.floor(Math.random() * f);
  }
  function E(e) {
    const t = S.extend({}, e);
    return "identify" === e.kind || "feature" === e.kind || "custom" === e.kind ? t.context = l.filter(e.context) : (t.contextKeys = Ae(e.context, p), delete t.context), "feature" === e.kind && (delete t.trackEvents, delete t.debugEventsUntilDate), t;
  }
  function D(e) {
    h.length < g ? (h.push(e), b = !1) : (b || (b = !0, p.warn(ae.eventCapacityExceeded())), r && r.incrementDroppedEvents());
  }
  return a.enqueue = function (e) {
    if (w) return;
    let t = !1,
      n = !1;
    var r;
    if (d.summarizeEvent(e), "feature" === e.kind ? k() && (t = !!e.trackEvents, n = !!(r = e).debugEventsUntilDate && r.debugEventsUntilDate > y && r.debugEventsUntilDate > new Date().getTime()) : t = k(), t && D(E(e)), n) {
      const t = S.extend({}, e, {
        kind: "debug"
      });
      t.context = l.filter(t.context), delete t.trackEvents, delete t.debugEventsUntilDate, D(t);
    }
  }, a.flush = async function () {
    if (w) return Promise.resolve();
    const e = h;
    return d.getSummaries().forEach(t => {
      Object.keys(t.features).length && e.push(t);
    }), r && r.setEventsInLastBatch(e.length), 0 === e.length ? Promise.resolve() : (h = [], p.debug(ae.debugPostingEvents(e.length)), c.sendEvents(e, u).then(e => {
      e && (e.serverTime && (y = e.serverTime), s.isHttpErrorRecoverable(e.status) || (w = !0), e.status >= 400 && S.onNextTick(() => {
        o.maybeReportError(new s.LDUnexpectedResponseError(ae.httpErrorMessage(e.status, "event posting", "some events were dropped")));
      }));
    }));
  }, a.start = function () {
    const e = () => {
      a.flush(), m = setTimeout(e, v);
    };
    m = setTimeout(e, v);
  }, a.stop = function () {
    clearTimeout(m);
  }, a;
};
var Re = function (e) {
  const t = {},
    n = {};
  return t.on = function (e, t, r) {
    n[e] = n[e] || [], n[e] = n[e].concat({
      handler: t,
      context: r
    });
  }, t.off = function (e, t, r) {
    if (n[e]) for (let o = 0; o < n[e].length; o++) n[e][o].handler === t && n[e][o].context === r && (n[e] = n[e].slice(0, o).concat(n[e].slice(o + 1)));
  }, t.emit = function (e) {
    if (!n[e]) return;
    const t = n[e].slice(0);
    for (let e = 0; e < t.length; e++) t[e].handler.apply(t[e].context, Array.prototype.slice.call(arguments, 1));
  }, t.getEvents = function () {
    return Object.keys(n);
  }, t.getEventListenerCount = function (e) {
    return n[e] ? n[e].length : 0;
  }, t.maybeReportError = function (t) {
    t && (n["error"] ? this.emit("error", t) : (e || console).error(t.message));
  }, t;
};
const Ne = "ready",
  $e = "initialized",
  Ve = "failed";
var He = function (e) {
  let t = !1,
    n = !1,
    r = null,
    o = null;
  const i = new Promise(t => {
    const n = () => {
      e.off(Ne, n), t();
    };
    e.on(Ne, n);
  }).catch(() => {});
  return {
    getInitializationPromise: () => o || (t ? Promise.resolve() : n ? Promise.reject(r) : (o = new Promise((t, n) => {
      const r = () => {
          e.off($e, r), t();
        },
        o = t => {
          e.off(Ve, o), n(t);
        };
      e.on($e, r), e.on(Ve, o);
    }), o)),
    getReadyPromise: () => i,
    signalSuccess: () => {
      t || n || (t = !0, e.emit($e), e.emit(Ne));
    },
    signalFailure: o => {
      t || n || (n = !0, r = o, e.emit(Ve, o), e.emit(Ne)), e.maybeReportError(o);
    }
  };
};
var Me = function (e, t, n, r) {
  const o = {};
  function i() {
    let e = "";
    const o = r.getContext();
    return o && (e = n || S.btoa(JSON.stringify(o))), "ld:" + t + ":" + e;
  }
  return o.loadFlags = () => e.get(i()).then(e => {
    if (null == e) return null;
    try {
      let t = JSON.parse(e);
      if (t) {
        const e = t.$schema;
        void 0 === e || e < 1 ? t = S.transformValuesToVersionedValues(t) : delete t.$schema;
      }
      return t;
    } catch (e) {
      return o.clearFlags().then(() => null);
    }
  }), o.saveFlags = t => {
    const n = S.extend({}, t, {
      $schema: 1
    });
    return e.set(i(), JSON.stringify(n));
  }, o.clearFlags = () => e.clear(i()), o;
};
var qe = function (e, t) {
  const n = {};
  let r = !1;
  const o = e => {
    r || (r = !0, t.warn(ae.localStorageUnavailable(e)));
  };
  return n.isEnabled = () => !!e, n.get = t => new Promise(n => {
    e ? e.get(t).then(n).catch(e => {
      o(e), n(void 0);
    }) : n(void 0);
  }), n.set = (t, n) => new Promise(r => {
    e ? e.set(t, n).then(() => r(!0)).catch(e => {
      o(e), r(!1);
    }) : r(!1);
  }), n.clear = t => new Promise(n => {
    e ? e.clear(t).then(() => n(!0)).catch(e => {
      o(e), n(!1);
    }) : n(!1);
  }), n;
};
const {
    appendUrlPath: ze,
    base64URLEncode: Ke,
    objectHasOwnProperty: _e
  } = S,
  {
    getLDHeaders: Je,
    transformHeaders: Be
  } = ve,
  {
    isHttpErrorRecoverable: We
  } = s;
var Ge = function (e, t, n, r) {
  const o = t.streamUrl,
    i = t.logger,
    a = {},
    s = ze(o, "/eval/" + n),
    c = t.useReport,
    u = t.evaluationReasons,
    l = t.streamReconnectDelay,
    d = Je(e, t);
  let f,
    g = !1,
    v = null,
    p = null,
    m = null,
    h = null,
    y = null,
    w = 0;
  function b() {
    const e = (t = function () {
      const e = l * Math.pow(2, w);
      return e > 3e4 ? 3e4 : e;
    }(), t - Math.trunc(.5 * Math.random() * t));
    var t;
    return w += 1, e;
  }
  function k(e) {
    if (e.status && "number" == typeof e.status && !We(e.status)) return x(), i.error(ae.unrecoverableStreamError(e)), void (p && (clearTimeout(p), p = null));
    const t = b();
    g || (i.warn(ae.streamError(e, t)), g = !0), O(!1), x(), E(t);
  }
  function E(e) {
    p || (e ? p = setTimeout(D, e) : D());
  }
  function D() {
    let r;
    p = null;
    let a = "";
    const l = {
      headers: d,
      readTimeoutMillis: 3e5
    };
    if (e.eventSourceFactory) {
      null != h && (a = "h=" + h), c ? e.eventSourceAllowsReport ? (r = s, l.method = "REPORT", l.headers["Content-Type"] = "application/json", l.body = JSON.stringify(m)) : (r = ze(o, "/ping/" + n), a = "") : r = s + "/" + Ke(JSON.stringify(m)), l.headers = Be(l.headers, t), u && (a = a + (a ? "&" : "") + "withReasons=true"), r = r + (a ? "?" : "") + a, x(), i.info(ae.streamConnecting(r)), f = new Date().getTime(), v = e.eventSourceFactory(r, l);
      for (const e in y) _e(y, e) && v.addEventListener(e, y[e]);
      v.onerror = k, v.onopen = () => {
        w = 0;
      };
    }
  }
  function x() {
    v && (i.info(ae.streamClosing()), v.close(), v = null);
  }
  function O(e) {
    f && r && r.recordStreamInit(f, !e, new Date().getTime() - f), f = null;
  }
  return a.connect = function (e, t, n) {
    m = e, h = t, y = {};
    for (const e in n || {}) y[e] = function (t) {
      g = !1, O(!0), n[e] && n[e](t);
    };
    E();
  }, a.disconnect = function () {
    clearTimeout(p), p = null, x();
  }, a.isConnected = function () {
    return !!(v && e.eventSourceIsActive && e.eventSourceIsActive(v));
  }, a;
};
var Xe = function (e) {
  let t, n, r, o;
  const i = {
    addPromise: (i, a) => {
      t = i, n && n(), n = a, i.then(n => {
        t === i && (r(n), e && e());
      }, n => {
        t === i && (o(n), e && e());
      });
    }
  };
  return i.resultPromise = new Promise((e, t) => {
    r = e, o = t;
  }), i;
};
const {
    transformHeaders: Qe,
    getLDHeaders: Ye
  } = ve,
  Ze = "application/json";
var et = function (e, t, n) {
  const r = t.baseUrl,
    o = t.useReport,
    i = t.evaluationReasons,
    a = t.logger,
    c = {},
    u = {};
  function l(n, r) {
    if (!e.httpRequest) return new Promise((e, t) => {
      t(new s.LDFlagFetchError(ae.httpUnavailable()));
    });
    const o = r ? "REPORT" : "GET",
      i = Ye(e, t);
    r && (i["Content-Type"] = Ze);
    let a = u[n];
    a || (a = Xe(() => {
      delete u[n];
    }), u[n] = a);
    const c = e.httpRequest(o, n, Qe(i, t), r),
      l = c.promise.then(e => {
        if (200 === e.status) {
          if (e.header("content-type") && e.header("content-type").substring(0, 16) === Ze) return JSON.parse(e.body);
          {
            const t = ae.invalidContentType(e.header("content-type") || "");
            return Promise.reject(new s.LDFlagFetchError(t));
          }
        }
        return Promise.reject(function (e) {
          return 404 === e.status ? new s.LDInvalidEnvironmentIdError(ae.environmentNotFound()) : new s.LDFlagFetchError(ae.errorFetchingFlags(e.statusText || String(e.status)));
        }(e));
      }, e => Promise.reject(new s.LDFlagFetchError(ae.networkError(e))));
    return a.addPromise(l, () => {
      c.cancel && c.cancel();
    }), a.resultPromise;
  }
  return c.fetchJSON = function (e) {
    return l(S.appendUrlPath(r, e), null);
  }, c.fetchFlagSettings = function (e, t) {
    let s,
      c,
      u,
      d = "";
    return o ? (c = [r, "/sdk/evalx/", n, "/context"].join(""), u = JSON.stringify(e)) : (s = S.base64URLEncode(JSON.stringify(e)), c = [r, "/sdk/evalx/", n, "/contexts/", s].join("")), t && (d = "h=" + t), i && (d = d + (d ? "&" : "") + "withReasons=true"), c = c + (d ? "?" : "") + d, a.debug(ae.debugPolling(c)), l(c, u);
  }, c;
};
var tt = function (e, t) {
  const n = {};
  let r;
  return n.setContext = function (e) {
    r = S.sanitizeContext(e), r && t && t(S.clone(r));
  }, n.getContext = function () {
    return r ? S.clone(r) : null;
  }, e && n.setContext(e), n;
};
const {
    v1: nt
  } = te,
  {
    getContextKinds: rt
  } = De;
var ot = function (e) {
  function t(e) {
    return null == e || "user" === e ? "ld:$anonUserId" : `ld:$contextKey:${e}`;
  }
  function n(n, r) {
    return null !== r.key && void 0 !== r.key ? (r.key = r.key.toString(), Promise.resolve(r)) : r.anonymous ? function (n) {
      return e.get(t(n));
    }(n).then(o => {
      if (o) return r.key = o, r;
      {
        const o = nt();
        return r.key = o, function (n, r) {
          return e.set(t(r), n);
        }(o, n).then(() => r);
      }
    }) : Promise.reject(new s.LDInvalidUserError(ae.invalidContext()));
  }
  this.processContext = e => {
    if (!e) return Promise.reject(new s.LDInvalidUserError(ae.contextNotSpecified()));
    const t = S.clone(e);
    if ("multi" === e.kind) {
      const e = rt(t);
      return Promise.all(e.map(e => n(e, t[e]))).then(() => t);
    }
    return n(e.kind, t);
  };
};
const {
    v1: it
  } = te,
  {
    baseOptionDefs: at
  } = fe,
  {
    appendUrlPath: st
  } = S;
var ct = {
  DiagnosticId: function (e) {
    const t = {
      diagnosticId: it()
    };
    return e && (t.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), t;
  },
  DiagnosticsAccumulator: function (e) {
    let t, n, r, o;
    function i(e) {
      t = e, n = 0, r = 0, o = [];
    }
    return i(e), {
      getProps: () => ({
        dataSinceDate: t,
        droppedEvents: n,
        eventsInLastBatch: r,
        streamInits: o
      }),
      setProps: e => {
        t = e.dataSinceDate, n = e.droppedEvents || 0, r = e.eventsInLastBatch || 0, o = e.streamInits || [];
      },
      incrementDroppedEvents: () => {
        n++;
      },
      setEventsInLastBatch: e => {
        r = e;
      },
      recordStreamInit: (e, t, n) => {
        const r = {
          timestamp: e,
          failed: t,
          durationMillis: n
        };
        o.push(r);
      },
      reset: i
    };
  },
  DiagnosticsManager: function (e, t, n, r, o, i, a) {
    const s = !!e.diagnosticUseCombinedEvent,
      c = "ld:" + o + ":$diagnostics",
      u = st(i.eventsUrl, "/events/diagnostic/" + o),
      l = i.diagnosticRecordingInterval,
      d = n;
    let f,
      g,
      v = !!i.streaming;
    const p = {};
    function m() {
      return {
        sdk: w(),
        configuration: b(),
        platform: e.diagnosticPlatformData
      };
    }
    function h(e) {
      i.logger && i.logger.debug(ae.debugPostingDiagnosticEvent(e)), r.sendEvents(e, u, !0).then(() => {}).catch(() => {});
    }
    function y() {
      h(function () {
        const e = new Date().getTime();
        let t = {
          kind: s ? "diagnostic-combined" : "diagnostic",
          id: a,
          creationDate: e,
          ...d.getProps()
        };
        return s && (t = {
          ...t,
          ...m()
        }), d.reset(e), t;
      }()), g = setTimeout(y, l), f = new Date().getTime(), s && function () {
        if (t.isEnabled()) {
          const e = {
            ...d.getProps()
          };
          t.set(c, JSON.stringify(e));
        }
      }();
    }
    function w() {
      const t = {
        ...e.diagnosticSdkData
      };
      return i.wrapperName && (t.wrapperName = i.wrapperName), i.wrapperVersion && (t.wrapperVersion = i.wrapperVersion), t;
    }
    function b() {
      return {
        customBaseURI: i.baseUrl !== at.baseUrl.default,
        customStreamURI: i.streamUrl !== at.streamUrl.default,
        customEventsURI: i.eventsUrl !== at.eventsUrl.default,
        eventsCapacity: i.eventCapacity,
        eventsFlushIntervalMillis: i.flushInterval,
        reconnectTimeMillis: i.streamReconnectDelay,
        streamingDisabled: !v,
        allAttributesPrivate: !!i.allAttributesPrivate,
        diagnosticRecordingIntervalMillis: i.diagnosticRecordingInterval,
        usingSecureMode: !!i.hash,
        bootstrapMode: !!i.bootstrap,
        fetchGoalsDisabled: !i.fetchGoals,
        sendEventsOnlyForVariation: !!i.sendEventsOnlyForVariation
      };
    }
    return p.start = () => {
      s ? function (e) {
        if (!t.isEnabled()) return e(!1);
        t.get(c).then(t => {
          if (t) try {
            const e = JSON.parse(t);
            d.setProps(e), f = e.dataSinceDate;
          } catch (e) {}
          e(!0);
        }).catch(() => {
          e(!1);
        });
      }(e => {
        if (e) {
          const e = (f || 0) + l,
            t = new Date().getTime();
          t >= e ? y() : g = setTimeout(y, e - t);
        } else 0 === Math.floor(4 * Math.random()) ? y() : g = setTimeout(y, l);
      }) : (h({
        kind: "diagnostic-init",
        id: a,
        creationDate: d.getProps().dataSinceDate,
        ...m()
      }), g = setTimeout(y, l));
    }, p.stop = () => {
      g && clearTimeout(g);
    }, p.setStreaming = e => {
      v = e;
    }, p;
  }
};
var ut = function (e, t) {
  let n = !1;
  const r = {
    type: e.type,
    name: e.name,
    synchronous: e.synchronous,
    method: function () {
      try {
        e.method(...arguments);
      } catch {
        n || (n = !0, t.warn(ae.inspectorMethodError(r.type, r.name)));
      }
    }
  };
  return r;
};
const {
    onNextTick: lt
  } = S,
  dt = {
    flagUsed: "flag-used",
    flagDetailsChanged: "flag-details-changed",
    flagDetailChanged: "flag-detail-changed",
    clientIdentityChanged: "client-identity-changed"
  };
Object.freeze(dt);
var ft = {
  InspectorTypes: dt,
  InspectorManager: function (e, t) {
    const n = {},
      r = {
        [dt.flagUsed]: [],
        [dt.flagDetailsChanged]: [],
        [dt.flagDetailChanged]: [],
        [dt.clientIdentityChanged]: []
      },
      o = {
        [dt.flagUsed]: [],
        [dt.flagDetailsChanged]: [],
        [dt.flagDetailChanged]: [],
        [dt.clientIdentityChanged]: []
      },
      i = e && e.map(e => ut(e, t));
    return i && i.forEach(e => {
      Object.prototype.hasOwnProperty.call(r, e.type) && !e.synchronous ? r[e.type].push(e) : Object.prototype.hasOwnProperty.call(o, e.type) && e.synchronous ? o[e.type].push(e) : t.warn(ae.invalidInspector(e.type, e.name));
    }), n.hasListeners = e => r[e] && r[e].length || o[e] && o[e].length, n.onFlagUsed = (e, t, n) => {
      const i = dt.flagUsed;
      o[i].length && o[i].forEach(r => r.method(e, t, n)), r[i].length && lt(() => {
        r[i].forEach(r => r.method(e, t, n));
      });
    }, n.onFlags = e => {
      const t = dt.flagDetailsChanged;
      o[t].length && o[t].forEach(t => t.method(e)), r[t].length && lt(() => {
        r[t].forEach(t => t.method(e));
      });
    }, n.onFlagChanged = (e, t) => {
      const n = dt.flagDetailChanged;
      o[n].length && o[n].forEach(n => n.method(e, t)), r[n].length && lt(() => {
        r[n].forEach(n => n.method(e, t));
      });
    }, n.onIdentityChanged = e => {
      const t = dt.clientIdentityChanged;
      o[t].length && o[t].forEach(t => t.method(e)), r[t].length && lt(() => {
        r[t].forEach(t => t.method(e));
      });
    }, n;
  }
};
const {
  LDTimeoutError: gt
} = s;
var vt = function (e, t) {
  return new Promise((n, r) => {
    setTimeout(() => {
      r(new gt(`${t} timed out after ${e} seconds.`));
    }, 1e3 * e);
  });
};
const pt = "unknown hook";
function mt(e, t, n, r, o) {
  try {
    return r();
  } catch (r) {
    return e !== null && e !== void 0 && e.error(`An error was encountered in "${t}" of the "${n}" hook: ${r}`), o;
  }
}
function ht(e, t) {
  try {
    return t.getMetadata().name || pt;
  } catch {
    return e.error("Exception thrown getting metadata for hook. Unable to get hook name."), pt;
  }
}
var yt = function (e, t) {
  const n = t ? [...t] : [];
  return {
    withEvaluation: function (t, r, o, i) {
      if (0 === n.length) return i();
      const a = [...n],
        s = {
          flagKey: t,
          context: r,
          defaultValue: o
        },
        c = function (e, t, n) {
          return t.map(t => mt(e, "beforeEvaluation", ht(e, t), () => {
            var _t$beforeEvaluation, _t$beforeEvaluation2;
            return (_t$beforeEvaluation = t === null || t === void 0 ? void 0 : (_t$beforeEvaluation2 = t.beforeEvaluation) === null || _t$beforeEvaluation2 === void 0 ? void 0 : _t$beforeEvaluation2.call(t, n, {})) !== null && _t$beforeEvaluation !== void 0 ? _t$beforeEvaluation : {};
          }, {}));
        }(e, a, s),
        u = i();
      return function (e, t, n, r, o) {
        for (let i = t.length - 1; i >= 0; i -= 1) {
          const a = t[i],
            s = r[i];
          mt(e, "afterEvaluation", ht(e, a), () => {
            var _a$afterEvaluation, _a$afterEvaluation2;
            return (_a$afterEvaluation = a === null || a === void 0 ? void 0 : (_a$afterEvaluation2 = a.afterEvaluation) === null || _a$afterEvaluation2 === void 0 ? void 0 : _a$afterEvaluation2.call(a, n, s, o)) !== null && _a$afterEvaluation !== void 0 ? _a$afterEvaluation : {};
          }, {});
        }
      }(e, a, s, c, u), u;
    },
    identify: function (t, r) {
      const o = [...n],
        i = {
          context: t,
          timeout: r
        },
        a = function (e, t, n) {
          return t.map(t => mt(e, "beforeIdentify", ht(e, t), () => {
            var _t$beforeIdentify, _t$beforeIdentify2;
            return (_t$beforeIdentify = t === null || t === void 0 ? void 0 : (_t$beforeIdentify2 = t.beforeIdentify) === null || _t$beforeIdentify2 === void 0 ? void 0 : _t$beforeIdentify2.call(t, n, {})) !== null && _t$beforeIdentify !== void 0 ? _t$beforeIdentify : {};
          }, {}));
        }(e, o, i);
      return t => {
        !function (e, t, n, r, o) {
          for (let i = t.length - 1; i >= 0; i -= 1) {
            const a = t[i],
              s = r[i];
            mt(e, "afterIdentify", ht(e, a), () => {
              var _a$afterIdentify, _a$afterIdentify2;
              return (_a$afterIdentify = a === null || a === void 0 ? void 0 : (_a$afterIdentify2 = a.afterIdentify) === null || _a$afterIdentify2 === void 0 ? void 0 : _a$afterIdentify2.call(a, n, s, o)) !== null && _a$afterIdentify !== void 0 ? _a$afterIdentify : {};
            }, {});
          }
        }(e, o, i, a, t);
      };
    },
    addHook: function (e) {
      n.push(e);
    },
    afterTrack: function (t) {
      if (0 === n.length) return;
      const r = [...n];
      !function (e, t, n) {
        for (let r = t.length - 1; r >= 0; r -= 1) {
          const o = t[r];
          mt(e, "afterTrack", ht(e, o), () => {
            var _o$afterTrack;
            return o === null || o === void 0 ? void 0 : (_o$afterTrack = o.afterTrack) === null || _o$afterTrack === void 0 ? void 0 : _o$afterTrack.call(o, n);
          }, void 0);
        }
      }(e, r, t);
    }
  };
};
var wt = function () {
  let e,
    t = {};
  function n(n) {
    return e && S.objectHasOwnProperty(e, n) && e[n] ? e[n] : t && S.objectHasOwnProperty(t, n) && t[n] && !t[n].deleted ? t[n] : null;
  }
  return {
    clearAllOverrides: function () {
      if (!e) return {};
      const t = {
        ...e
      };
      return e = void 0, t;
    },
    get: n,
    getFlagOverrides: function () {
      return e || {};
    },
    getFlags: function () {
      return t;
    },
    getFlagsWithOverrides: function () {
      const r = {};
      for (const e in t) {
        const t = n(e);
        t && (r[e] = t);
      }
      if (e) for (const t in e) {
        const e = n(t);
        e && (r[t] = e);
      }
      return r;
    },
    removeOverride: function (t) {
      e && e[t] && (delete e[t], 0 === Object.keys(e).length && (e = void 0));
    },
    setFlags: function (e) {
      t = {
        ...e
      };
    },
    setOverride: function (t, n) {
      e || (e = {}), e[t] = {
        value: n
      };
    }
  };
};
const bt = "unknown plugin";
function kt(e, t) {
  try {
    return t.getMetadata().name || bt;
  } catch (t) {
    return e.error("Exception thrown getting metadata for plugin. Unable to get plugin name."), bt;
  }
}
var Et = {
  getPluginHooks: function (e, t, n) {
    const r = [];
    return n.forEach(n => {
      try {
        var _n$getHooks;
        const o = (_n$getHooks = n.getHooks) === null || _n$getHooks === void 0 ? void 0 : _n$getHooks.call(n, t);
        void 0 === o ? e.error(`Plugin ${kt(e, n)} returned undefined from getHooks.`) : o && o.length > 0 && r.push(...o);
      } catch (t) {
        e.error(`Exception thrown getting hooks for plugin ${kt(e, n)}. Unable to get hooks.`);
      }
    }), r;
  },
  registerPlugins: function (e, t, n, r) {
    r.forEach(r => {
      try {
        r.register(n, t);
      } catch (t) {
        e.error(`Exception thrown registering plugin ${kt(e, r)}.`);
      }
    });
  },
  registerPluginsForDebugOverride: function (e, t, n) {
    n.forEach(n => {
      try {
        var _n$registerDebug;
        (_n$registerDebug = n.registerDebug) === null || _n$registerDebug === void 0 ? void 0 : _n$registerDebug.call(n, t);
      } catch (t) {
        e.error(`Exception thrown registering debug override with plugin ${kt(e, n)}.`);
      }
    });
  },
  createPluginEnvironment: function (e, t, n) {
    const r = {};
    e.userAgent && (r.name = e.userAgent), e.version && (r.version = e.version), n.wrapperName && (r.wrapperName = n.wrapperName), n.wrapperVersion && (r.wrapperVersion = n.wrapperVersion);
    const o = {};
    n.application && (n.application.name && (o.name = n.application.name), n.application.version && (o.version = n.application.version));
    const i = {
      sdk: r,
      clientSideId: t
    };
    return Object.keys(o).length > 0 && (i.application = o), i;
  }
};
const {
    commonBasicLogger: Dt
  } = re,
  {
    checkContext: xt,
    getContextKeys: Ot
  } = De,
  {
    InspectorTypes: Ct,
    InspectorManager: Pt
  } = ft,
  {
    getPluginHooks: St,
    registerPlugins: It,
    registerPluginsForDebugOverride: Tt,
    createPluginEnvironment: Ft
  } = Et,
  Lt = "change",
  Ut = "internal-change";
var At = {
    initialize: function (e, t, n, r, o) {
      const i = function () {
          if (n && n.logger) return n.logger;
          return o && o.logger && o.logger.default || Dt("warn");
        }(),
        a = Re(i),
        c = He(a),
        u = fe.validate(n, a, o, i),
        l = Pt(u.inspectors, i),
        d = u.sendEvents;
      let f = e,
        g = u.hash;
      const v = [...u.plugins],
        p = Ft(r, e, u),
        m = St(i, p, v),
        h = yt(i, [...u.hooks, ...m]),
        y = qe(r.localStorage, i),
        w = ye(r, f, u),
        b = u.sendEvents && !u.diagnosticOptOut,
        k = b ? ct.DiagnosticId(f) : null,
        E = b ? ct.DiagnosticsAccumulator(new Date().getTime()) : null,
        D = b ? ct.DiagnosticsManager(r, y, E, w, f, u, k) : null,
        x = Ge(r, u, f, E),
        O = u.eventProcessor || je(r, u, f, E, a, w),
        C = et(r, u, f),
        P = wt();
      let I,
        T,
        F,
        L = u.streaming,
        U = !1,
        A = !1,
        j = !0;
      const R = u.stateProvider,
        N = tt(null, function (e) {
          (function (e) {
            if (R) return;
            e && H({
              kind: "identify",
              context: e,
              creationDate: new Date().getTime()
            });
          })(e), l.hasListeners(Ct.clientIdentityChanged) && l.onIdentityChanged(N.getContext());
        }),
        $ = new ot(y),
        V = y.isEnabled() ? Me(y, f, g, N) : null;
      function H(e) {
        f && (R && R.enqueueEvent && R.enqueueEvent(e) || (e.context ? (j = !1, !d || A || r.isDoNotTrack() || (i.debug(ae.debugEnqueueingEvent(e.kind)), O.enqueue(e))) : j && (i.warn(ae.eventWithoutContext()), j = !1)));
      }
      function M(e, t) {
        l.hasListeners(Ct.flagDetailChanged) && l.onFlagChanged(e.key, J(t));
      }
      function q() {
        l.hasListeners(Ct.flagDetailsChanged) && l.onFlags(Object.entries(P.getFlagsWithOverrides()).map(_ref4 => {
          let [e, t] = _ref4;
          return {
            key: e,
            detail: J(t)
          };
        }).reduce((e, t) => (e[t.key] = t.detail, e), {}));
      }
      function z(e, t, n, r) {
        const o = N.getContext(),
          i = new Date(),
          a = {
            kind: "feature",
            key: e,
            context: o,
            value: t ? t.value : null,
            variation: t ? t.variationIndex : null,
            default: n,
            creationDate: i.getTime()
          },
          s = P.getFlags()[e];
        s && (a.version = s.flagVersion ? s.flagVersion : s.version, a.trackEvents = s.trackEvents, a.debugEventsUntilDate = s.debugEventsUntilDate), (r || s && s.trackReason) && t && (a.reason = t.reason), H(a);
      }
      function K(e) {
        return xt(e, !1) ? Promise.resolve(e) : Promise.reject(new s.LDInvalidUserError(ae.invalidContext()));
      }
      function _(e, t, n, r, o, i) {
        var _s$prerequisites;
        let a;
        const s = P.get(e);
        return s ? (a = J(s), null !== s.value && void 0 !== s.value || (a.value = t)) : a = {
          value: t,
          variationIndex: null,
          reason: {
            kind: "ERROR",
            errorKind: "FLAG_NOT_FOUND"
          }
        }, n && (o || s !== null && s !== void 0 && (_s$prerequisites = s.prerequisites) !== null && _s$prerequisites !== void 0 && _s$prerequisites.forEach(e => {
          _(e, void 0, n, !1, !1, !1);
        }), z(e, a, t, r)), !o && i && function (e, t) {
          l.hasListeners(Ct.flagUsed) && l.onFlagUsed(e, t, N.getContext());
        }(e, a), a;
      }
      function J(e) {
        return {
          value: e.value,
          variationIndex: void 0 === e.variation ? null : e.variation,
          reason: e.reason || null
        };
      }
      function B() {
        if (T = !0, !N.getContext()) return;
        const e = e => {
          try {
            return JSON.parse(e);
          } catch (e) {
            return void a.maybeReportError(new s.LDInvalidDataError(ae.invalidData()));
          }
        };
        x.connect(N.getContext(), g, {
          ping: function () {
            i.debug(ae.debugStreamPing());
            const e = N.getContext();
            C.fetchFlagSettings(e, g).then(t => {
              S.deepEquals(e, N.getContext()) && G(t || {});
            }).catch(e => {
              a.maybeReportError(new s.LDFlagFetchError(ae.errorFetchingFlags(e)));
            });
          },
          put: function (t) {
            const n = e(t.data);
            n && (i.debug(ae.debugStreamPut()), G(n));
          },
          patch: function (t) {
            const n = e(t.data);
            if (!n) return;
            const r = P.getFlags(),
              o = r[n.key];
            if (!o || !o.version || !n.version || o.version < n.version) {
              i.debug(ae.debugStreamPatch(n.key));
              const e = {},
                t = S.extend({}, n);
              delete t.key, r[n.key] = t, P.setFlags(r);
              const a = J(t);
              e[n.key] = o ? {
                previous: o.value,
                current: a
              } : {
                current: a
              }, M(n, t), X(e);
            } else i.debug(ae.debugStreamPatchIgnored(n.key));
          },
          delete: function (t) {
            const n = e(t.data);
            if (!n) return;
            const r = P.getFlags();
            if (!r[n.key] || r[n.key].version < n.version) {
              i.debug(ae.debugStreamDelete(n.key));
              const e = {};
              r[n.key] && !r[n.key].deleted && (e[n.key] = {
                previous: r[n.key].value
              }), r[n.key] = {
                version: n.version,
                deleted: !0
              }, P.setFlags(r), M(n, r[n.key]), X(e);
            } else i.debug(ae.debugStreamDeleteIgnored(n.key));
          }
        });
      }
      function W() {
        T && (x.disconnect(), T = !1);
      }
      function G(e) {
        const t = {};
        if (!e) return Promise.resolve();
        const n = P.getFlags();
        for (const r in n) S.objectHasOwnProperty(n, r) && n[r] && (e[r] && !S.deepEquals(e[r].value, n[r].value) ? t[r] = {
          previous: n[r].value,
          current: J(e[r])
        } : e[r] && !e[r].deleted || (t[r] = {
          previous: n[r].value
        }));
        for (const r in e) S.objectHasOwnProperty(e, r) && e[r] && (!n[r] || n[r].deleted) && (t[r] = {
          current: J(e[r])
        });
        return P.setFlags({
          ...e
        }), q(), X(t).catch(() => {});
      }
      function X(e) {
        const t = Object.keys(e);
        if (t.length > 0) {
          const n = {};
          t.forEach(t => {
            const r = e[t].current,
              o = r ? r.value : void 0,
              i = e[t].previous;
            a.emit(Lt + ":" + t, o, i), n[t] = r ? {
              current: o,
              previous: i
            } : {
              previous: i
            };
          }), a.emit(Lt, n), a.emit(Ut, P.getFlagsWithOverrides()), u.sendEventsOnlyForVariation || R || t.forEach(t => {
            z(t, e[t].current);
          });
        }
        return I && V ? V.saveFlags(P.getFlags()) : Promise.resolve();
      }
      function Q() {
        const e = L || F && void 0 === L;
        e && !T ? B() : !e && T && W(), D && D.setStreaming(e);
      }
      function Y(e) {
        return e === Lt || e.substr(0, 7) === Lt + ":";
      }
      if ("string" == typeof u.bootstrap && "LOCALSTORAGE" === u.bootstrap.toUpperCase() && (V ? I = !0 : i.warn(ae.localStorageUnavailable())), "object" == typeof u.bootstrap && P.setFlags(function (e) {
        const t = Object.keys(e),
          n = "$flagsState",
          r = "$valid",
          o = e[n];
        !o && t.length && i.warn(ae.bootstrapOldFormat()), !1 === e[r] && i.warn(ae.bootstrapInvalid());
        const a = {};
        return t.forEach(t => {
          if (t !== n && t !== r) {
            let n = {
              value: e[t]
            };
            o && o[t] ? n = S.extend(n, o[t]) : n.version = 0, a[t] = n;
          }
        }), a;
      }(u.bootstrap)), R) {
        const e = R.getInitialState();
        e ? Z(e) : R.on("init", Z), R.on("update", function (e) {
          e.context && N.setContext(e.context);
          e.flags && G(e.flags);
        });
      } else (function () {
        if (!e) return Promise.reject(new s.LDInvalidEnvironmentIdError(ae.environmentNotSpecified()));
        let n;
        return $.processContext(t).then(K).then(e => (n = S.once(h.identify(e, void 0)), e)).then(e => {
          var _n;
          return (_n = n) !== null && _n !== void 0 && _n({
            status: "completed"
          }), N.setContext(e), "object" == typeof u.bootstrap ? ee() : I ? V.loadFlags().then(e => null == e ? (P.setFlags({}), C.fetchFlagSettings(N.getContext(), g).then(e => G(e || {})).then(ee).catch(e => {
            te(new s.LDFlagFetchError(ae.errorFetchingFlags(e)));
          })) : (P.setFlags(e), S.onNextTick(ee), C.fetchFlagSettings(N.getContext(), g).then(e => G(e)).catch(e => a.maybeReportError(e)))) : C.fetchFlagSettings(N.getContext(), g).then(e => {
            P.setFlags(e || {}), q(), ee();
          }).catch(e => {
            P.setFlags({}), te(e);
          });
        }).catch(e => {
          var _n2;
          throw (_n2 = n) !== null && _n2 !== void 0 && _n2({
            status: "error"
          }), e;
        });
      })().catch(te);
      function Z(e) {
        f = e.environment, N.setContext(e.context), P.setFlags({
          ...e.flags
        }), S.onNextTick(ee);
      }
      function ee() {
        i.info(ae.clientInitialized()), U = !0, Q(), c.signalSuccess();
      }
      function te(e) {
        c.signalFailure(e);
      }
      const ne = {
        waitForInitialization: function () {
          let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : void 0;
          if (null != e) {
            if ("number" == typeof e) return function (e) {
              e > 5 && i.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");
              const t = c.getInitializationPromise(),
                n = vt(e, "waitForInitialization");
              return Promise.race([n, t]).catch(e => {
                throw e instanceof s.LDTimeoutError && i.error(`waitForInitialization error: ${e}`), e;
              });
            }(e);
            i.warn("The waitForInitialization method was provided with a non-numeric timeout.");
          }
          return i.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."), c.getInitializationPromise();
        },
        waitUntilReady: () => c.getReadyPromise(),
        identify: function (e, t, n) {
          if (A) return S.wrapPromiseCallback(Promise.resolve({}), n);
          if (R) return i.warn(ae.identifyDisabled()), S.wrapPromiseCallback(Promise.resolve(S.transformVersionedValuesToValues(P.getFlagsWithOverrides())), n);
          let r;
          const o = I && V ? V.clearFlags() : Promise.resolve();
          return S.wrapPromiseCallback(o.then(() => $.processContext(e)).then(K).then(e => (r = S.once(h.identify(e, void 0)), e)).then(e => C.fetchFlagSettings(e, t).then(n => {
            const r = S.transformVersionedValuesToValues(n);
            return N.setContext(e), g = t, n ? G(n).then(() => r) : r;
          })).then(e => {
            var _r;
            return (_r = r) !== null && _r !== void 0 && _r({
              status: "completed"
            }), T && B(), e;
          }).catch(e => {
            var _r2;
            return (_r2 = r) !== null && _r2 !== void 0 && _r2({
              status: "error"
            }), a.maybeReportError(e), Promise.reject(e);
          }), n);
        },
        getContext: function () {
          return N.getContext();
        },
        variation: function (e, t) {
          const {
            value: n
          } = h.withEvaluation(e, N.getContext(), t, () => _(e, t, !0, !1, !1, !0));
          return n;
        },
        variationDetail: function (e, t) {
          return h.withEvaluation(e, N.getContext(), t, () => _(e, t, !0, !0, !1, !0));
        },
        track: function (e, t, n) {
          if ("string" != typeof e) return void a.maybeReportError(new s.LDInvalidEventKeyError(ae.unknownCustomEventKey(e)));
          void 0 !== n && "number" != typeof n && i.warn(ae.invalidMetricValue(typeof n)), r.customEventFilter && !r.customEventFilter(e) && i.warn(ae.unknownCustomEventKey(e));
          const o = N.getContext(),
            c = {
              kind: "custom",
              key: e,
              context: o,
              url: r.getCurrentUrl(),
              creationDate: new Date().getTime()
            };
          o && o.anonymous && (c.contextKind = o.anonymous ? "anonymousUser" : "user"), null != t && (c.data = t), null != n && (c.metricValue = n), H(c), h.afterTrack({
            context: o,
            key: e,
            data: t,
            metricValue: n
          });
        },
        on: function (e, t, n) {
          Y(e) ? (F = !0, U && Q(), a.on(e, t, n)) : a.on(...arguments);
        },
        off: function (e) {
          if (a.off(...arguments), Y(e)) {
            let e = !1;
            a.getEvents().forEach(t => {
              Y(t) && a.getEventListenerCount(t) > 0 && (e = !0);
            }), e || (F = !1, T && void 0 === L && W());
          }
        },
        setStreaming: function (e) {
          const t = null === e ? void 0 : e;
          t !== L && (L = t, Q());
        },
        flush: function (e) {
          return S.wrapPromiseCallback(d ? O.flush() : Promise.resolve(), e);
        },
        allFlags: function () {
          const e = {},
            t = P.getFlagsWithOverrides();
          if (!t) return e;
          for (const n in t) e[n] = _(n, null, !u.sendEventsOnlyForVariation, !1, !0, !1).value;
          return e;
        },
        close: function (e) {
          if (A) return S.wrapPromiseCallback(Promise.resolve(), e);
          const t = () => {
              A = !0, P.setFlags({});
            },
            n = Promise.resolve().then(() => {
              if (W(), D && D.stop(), d) return O.stop(), O.flush();
            }).then(t).catch(t);
          return S.wrapPromiseCallback(n, e);
        },
        addHook: function (e) {
          h.addHook(e);
        }
      };
      It(i, p, ne, v);
      const re = {
        setOverride: function (e, t) {
          const n = {},
            r = P.get(e),
            o = r ? r.value : null;
          if (o === t) return void i.debug(`setOverride: No change needed for ${e}, value already ${t}`);
          P.setOverride(e, t);
          const a = P.get(e),
            s = J(a);
          n[e] = {
            previous: o,
            current: s
          }, M({
            key: e
          }, a), X(n);
        },
        removeOverride: function (e) {
          const t = P.getFlagOverrides();
          if (!t[e]) return;
          const n = {},
            r = t[e],
            o = P.getFlags()[e];
          n[e] = {
            previous: r.value,
            current: o ? J(o) : void 0
          }, P.removeOverride(e), M({
            key: e
          }, o), X(n);
        },
        clearAllOverrides: function () {
          const e = P.getFlagOverrides();
          if (0 === Object.keys(e).length) return;
          const t = {},
            n = P.getFlags();
          Object.keys(e).forEach(r => {
            const o = e[r],
              i = n[r];
            t[r] = {
              previous: o.value,
              current: i ? J(i) : void 0
            };
          }), P.clearAllOverrides(), Object.keys(t).length > 0 && X(t);
        },
        getAllOverrides: function () {
          const e = P.getFlagOverrides();
          if (!e) return {};
          const t = {};
          return Object.keys(e).forEach(n => {
            const r = e[n];
            r && (t[n] = r.value);
          }), t;
        }
      };
      return Tt(i, re, v), {
        client: ne,
        options: u,
        emitter: a,
        ident: N,
        logger: i,
        requestor: C,
        start: function () {
          d && (D && D.start(), O.start());
        },
        enqueueEvent: H,
        getFlagsInternal: function () {
          return P.getFlagsWithOverrides();
        },
        getEnvironmentId: () => f,
        internalChangeEventName: Ut
      };
    },
    commonBasicLogger: Dt,
    errors: s,
    messages: ae,
    utils: S,
    getContextKeys: Ot
  },
  jt = At.initialize,
  Rt = At.errors,
  Nt = At.messages;
function $t(e, t, n) {
  return (t = function (e) {
    var t = function (e, t) {
      if ("object" != typeof e || !e) return e;
      var n = e[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(e, t || "default");
        if ("object" != typeof r) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }(e, "string");
    return "symbol" == typeof t ? t : t + "";
  }(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Vt(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ht(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Vt(Object(n), !0).forEach(function (t) {
      $t(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vt(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
var Mt = At.commonBasicLogger;
var qt = function (e) {
  return Mt(Ht({
    destination: console.log
  }, e));
};
var zt = {
  promise: Promise.resolve({
    status: 200,
    header: function () {
      return null;
    },
    body: null
  })
};
function Kt(e, t, n, r, o) {
  if (o && !function () {
    var e = window.navigator && window.navigator.userAgent;
    if (e) {
      var t = e.match(/Chrom(e|ium)\/([0-9]+)\./);
      if (t) return parseInt(t[2], 10) < 73;
    }
    return !0;
  }()) return zt;
  var i = new window.XMLHttpRequest();
  for (var a in i.open(e, t, !o), n || {}) Object.prototype.hasOwnProperty.call(n, a) && i.setRequestHeader(a, n[a]);
  if (o) {
    try {
      i.send(r);
    } catch (e) {}
    return zt;
  }
  var s,
    c = new Promise(function (e, t) {
      i.addEventListener("load", function () {
        s || e({
          status: i.status,
          header: function (e) {
            return i.getResponseHeader(e);
          },
          body: i.responseText
        });
      }), i.addEventListener("error", function () {
        s || t(new Error());
      }), i.send(r);
    });
  return {
    promise: c,
    cancel: function () {
      s = !0, i.abort();
    }
  };
}
var _t = e => {
  if ("string" != typeof e) throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function Jt(e, t, n, r) {
  var o,
    i,
    a = (("substring" === e.kind || "regex" === e.kind) && r.includes("/") ? t : t.replace(r, "")).replace(n, "");
  switch (e.kind) {
    case "exact":
      i = t, o = new RegExp("^" + _t(e.url) + "/?$");
      break;
    case "canonical":
      i = a, o = new RegExp("^" + _t(e.url) + "/?$");
      break;
    case "substring":
      i = a, o = new RegExp(".*" + _t(e.substring) + ".*$");
      break;
    case "regex":
      i = a, o = new RegExp(e.pattern);
      break;
    default:
      return !1;
  }
  return o.test(i);
}
function Bt(e, t) {
  for (var n = {}, r = null, o = [], i = 0; i < e.length; i++) for (var a = e[i], s = a.urls || [], c = 0; c < s.length; c++) if (Jt(s[c], window.location.href, window.location.search, window.location.hash)) {
    "pageview" === a.kind ? t("pageview", a) : (o.push(a), t("click_pageview", a));
    break;
  }
  return o.length > 0 && (r = function (e) {
    for (var n = function (e, t) {
        for (var n = [], r = 0; r < t.length; r++) for (var o = e.target, i = t[r], a = i.selector, s = document.querySelectorAll(a); o && s.length > 0;) {
          for (var c = 0; c < s.length; c++) o === s[c] && n.push(i);
          o = o.parentNode;
        }
        return n;
      }(e, o), r = 0; r < n.length; r++) t("click", n[r]);
  }, document.addEventListener("click", r)), n.dispose = function () {
    document.removeEventListener("click", r);
  }, n;
}
function Wt(e, t) {
  var n, r;
  function o() {
    r && r.dispose(), n && n.length && (r = Bt(n, i));
  }
  function i(t, n) {
    var r = e.ident.getContext(),
      o = {
        kind: t,
        key: n.key,
        data: null,
        url: window.location.href,
        creationDate: new Date().getTime(),
        context: r
      };
    return "click" === t && (o.selector = n.selector), e.enqueueEvent(o);
  }
  return e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function (e) {
    e && e.length > 0 && (r = Bt(n = e, i), function (e, t) {
      var n,
        r = window.location.href;
      function o() {
        (n = window.location.href) !== r && (r = n, t());
      }
      !function e(t, n) {
        t(), setTimeout(function () {
          e(t, n);
        }, n);
      }(o, e), window.history && window.history.pushState ? window.addEventListener("popstate", o) : window.addEventListener("hashchange", o);
    }(300, o)), t();
  }).catch(function (n) {
    e.emitter.maybeReportError(new Rt.LDUnexpectedResponseError((n && n.message, n.message))), t();
  }), {};
}
var Gt = "goalsReady",
  Xt = {
    fetchGoals: {
      default: !0
    },
    hash: {
      type: "string"
    },
    eventProcessor: {
      type: "object"
    },
    eventUrlTransformer: {
      type: "function"
    },
    disableSyncEventPost: {
      default: !1
    }
  };
function Qt(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    r = function (e) {
      var t,
        n = {
          userAgentHeaderName: "X-LaunchDarkly-User-Agent",
          synchronousFlush: !1
        };
      if (window.XMLHttpRequest) {
        var r = e && e.disableSyncEventPost;
        n.httpRequest = function (e, t, o, i) {
          var a = n.synchronousFlush & !r;
          return n.synchronousFlush = !1, Kt(e, t, o, i, a);
        };
      }
      n.httpAllowsPost = function () {
        return void 0 === t && (t = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest()), t;
      }, n.httpFallbackPing = function (e) {
        new window.Image().src = e;
      };
      var o,
        i = e && e.eventUrlTransformer;
      n.getCurrentUrl = function () {
        return i ? i(window.location.href) : window.location.href;
      }, n.isDoNotTrack = function () {
        var e;
        return 1 === (e = window.navigator && void 0 !== window.navigator.doNotTrack ? window.navigator.doNotTrack : window.navigator && void 0 !== window.navigator.msDoNotTrack ? window.navigator.msDoNotTrack : window.doNotTrack) || !0 === e || "1" === e || "yes" === e;
      };
      try {
        window.localStorage && (n.localStorage = {
          get: function (e) {
            return new Promise(function (t) {
              t(window.localStorage.getItem(e));
            });
          },
          set: function (e, t) {
            return new Promise(function (n) {
              window.localStorage.setItem(e, t), n();
            });
          },
          clear: function (e) {
            return new Promise(function (t) {
              window.localStorage.removeItem(e), t();
            });
          }
        });
      } catch (e) {
        n.localStorage = null;
      }
      if (e && e.useReport && "function" == typeof window.EventSourcePolyfill && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (n.eventSourceAllowsReport = !0, o = window.EventSourcePolyfill) : (n.eventSourceAllowsReport = !1, o = window.EventSource), window.EventSource) {
        var a = 3e5;
        n.eventSourceFactory = function (e, t) {
          var n = Ht(Ht({}, {
            heartbeatTimeout: a,
            silentTimeout: a,
            skipDefaultHeaders: !0
          }), t);
          return new o(e, n);
        }, n.eventSourceIsActive = function (e) {
          return e.readyState === window.EventSource.OPEN || e.readyState === window.EventSource.CONNECTING;
        };
      }
      return n.userAgent = "JSClient", n.version = "3.9.0", n.diagnosticSdkData = {
        name: "js-client-sdk",
        version: "3.9.0"
      }, n.diagnosticPlatformData = {
        name: "JS"
      }, n.diagnosticUseCombinedEvent = !0, n;
    }(n),
    o = jt(e, t, n, r, Xt),
    i = o.client,
    a = o.options,
    s = o.emitter,
    c = new Promise(function (e) {
      var t = s.on(Gt, function () {
        s.off(Gt, t), e();
      });
    });
  i.waitUntilGoalsReady = function () {
    return c;
  }, a.fetchGoals ? Wt(o, function () {
    return s.emit(Gt);
  }) : s.emit(Gt), "complete" !== document.readyState ? window.addEventListener("load", o.start) : o.start();
  var u = function () {
    r.synchronousFlush = !0, i.flush().catch(function () {}), r.synchronousFlush = !1;
  };
  return document.addEventListener("visibilitychange", function () {
    "hidden" === document.visibilityState && u();
  }), window.addEventListener("pagehide", u), i;
}
var Yt = qt,
  Zt = void 0,
  en = "3.9.0";
var tn = {
  initialize: function (e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    return console && console.warn && console.warn(Nt.deprecated("default export", "named LDClient export")), Qt(e, t, n);
  },
  version: en
};
export { Yt as basicLogger, Zt as createConsoleLogger, tn as default, Qt as initialize, en as version };